import React from 'react'
import Configurations from "../Tabs/Cns/Configurations"
import PAExtensions from "../Tabs/Cns/PAExtensions"
import RejectedExtensions from "../Tabs/Cns/RejectedExtensions"
import { Tabs, Box } from "@mui/material";
import { useSelector } from 'react-redux';
import { currentTabIndex } from '../Redux/TabIndexSlice';
import { useDispatch } from 'react-redux';
import { getTabsByRole } from './Tabs';
import MNRBase from '../Tabs/Mnr/MNRBase';
import { resetToaster as paReset } from '../Redux/CNS/PAExtensionsSlice';
import { resetToaster as rejectedReset } from '../Redux/CNS/RejectedExtensionsSlice';
import { resetToaster as configReset } from '../Redux/CNS/ConfigurationsSlice';
import ReportsBase from '../Tabs/Mnr/ReportsBase';
import CocaAnnualBase from '../Tabs/Mnr/CocaAnnualBase';
import { mnrTabIndex } from '../Redux/TabIndexSlice';
//import { showAll } from '../Redux/MNR/MemberByPlanYearSlice';

function TabContent() {
    const dispatch = useDispatch();
    const tab = useSelector(state => state.tab.tab);
    const isSmall = useSelector(state => state.resolution.isSmall);
    const cns = useSelector(state => state.role.cns);
    const mnr = useSelector(state => state.role.mnr);
    const reports = useSelector(state => state.role.reports);

    const handleCurrentTabChanges = (e, value) => {
        dispatch(paReset());
        dispatch(rejectedReset());
        dispatch(configReset());
        dispatch(currentTabIndex(value));
        dispatch(mnrTabIndex(0));
    }

    const renderContent = () => {
        const menuLabels = [];

        if (cns) {
            menuLabels.push("PA Extensions", "Rejected Extensions", "Configurations");
        }
        if (mnr) {
            menuLabels.push("MNR");
        }
        if (reports) {
            menuLabels.push("Reports", "Coca Annual");
        }

        const componentMap = {
            "PA Extensions": <PAExtensions />,
            "Rejected Extensions": <RejectedExtensions />,
            "Configurations": <Configurations />,
            "MNR": <MNRBase />,
            "Reports": <ReportsBase />,
            "Coca Annual": <CocaAnnualBase />
        };

        const currentLabel = menuLabels[tab];
        const padding = ["PA Extensions", "Rejected Extensions", "Configurations"].includes(currentLabel)
            ? "24px"
            : "0";

        return (
            <Box style={{ padding }}>
                {componentMap[currentLabel] || <PAExtensions />}
            </Box>
        );
    };

    return (
        <>
            {isSmall === false &&
                <Tabs
                    value={tab}
                    onChange={handleCurrentTabChanges}
                    style={{ background: '#444', paddingLeft: '8px' }}
                    TabIndicatorProps={{
                        sx: {
                            backgroundColor: 'var(--secondary-color)',
                        },
                    }}
                >
                    {getTabsByRole(cns, mnr, reports)}
                </Tabs >
            }
            {(() => {
                return (
                    renderContent()
                );
            })()}
        </>
    )
}

export default TabContent